import {GameObject, HelperFunctions} from "../../tsthree";
import {Container, Graphics, NineSlicePlane, Sprite, Text, TextStyle, Texture} from "pixi.js";
import {GAME_FONT} from "../Constants/Constants";
import TaggedText from "pixi-tagged-text";
import {TextStyleExtended} from "pixi-tagged-text/dist/types";
import {buttonify} from "../../engine/HelperFunctions/buttonify";
import {getRelativePosition} from "../../engine/HelperFunctions/getRelativePosition";

let CURRENTLY_SELECTED_DROPDOWN: DropdownPrefab | null = null;

export class DropdownPrefab extends GameObject {

    private _sharedTextStyle: TextStyleExtended = {
        fontFamily: GAME_FONT,
        fill: 0x000000,
        fontSize: 11,
        align: "left",
        lineHeight: 16,
    };
    private _currentEntries: string[] = [];

    private currentSelectedText: Text;
    private selectedOptionGraphic: Graphics;
    private currentSelectedIndex: number = -1;
    private optionsText: TaggedText;
    private optionsBg: NineSlicePlane;

    public get currentValue(): string {
        return this._currentEntries[this.currentSelectedIndex];
    }

    constructor(_settings: {
        width: number;
        onSelect: (_selectedValue: string) => void;
    }) {
        super("DropdownPrefab");

        const height = 20;
        const bg = new NineSlicePlane(
            ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        );
        bg.width = _settings.width;
        bg.height = height;
        this.addChild(bg);

        const currentSelectedText = this.currentSelectedText = new Text("", this._sharedTextStyle as unknown as TextStyle);
        currentSelectedText.anchor.set(0, 1);
        currentSelectedText.position.set(4, height - 1);
        bg.addChild(currentSelectedText);

        const dropDownArrow = new Sprite(
            ENGINE.getPIXIResource("down-arrow") as Texture
        );
        dropDownArrow.anchor.set(1, 0);
        dropDownArrow.position.set(_settings.width - 2, 2);
        bg.addChild(dropDownArrow);
        buttonify(dropDownArrow,  {
            onFire: () => {
                this.optionsBg.parent.visible = !this.optionsBg.parent.visible;
                if(
                    CURRENTLY_SELECTED_DROPDOWN &&
                    CURRENTLY_SELECTED_DROPDOWN !== this
                ) {
                    CURRENTLY_SELECTED_DROPDOWN.optionsBg.parent.visible = false;
                    CURRENTLY_SELECTED_DROPDOWN = this;
                } else if(this.optionsBg.parent.visible) {
                    CURRENTLY_SELECTED_DROPDOWN = this;
                }
            }
        });

        const optionsContainer = new Container();
        optionsContainer.position.set(0, height);
        this.addChild(optionsContainer);

        const optionsBg = this.optionsBg = new NineSlicePlane(
            ENGINE.getPIXIResource("white-square-stroke") as Texture,
            2,
            2,
            2,
            2,
        );
        optionsBg.width = _settings.width;
        optionsBg.height = 16;
        optionsContainer.addChild(optionsBg);
        const selectedOption = this.selectedOptionGraphic = new Graphics();
        selectedOption.beginFill(0x0000ff, 1);
        selectedOption.drawRect(0, 0, _settings.width, 16);
        selectedOption.endFill();
        optionsContainer.addChild(selectedOption);
        const optionsText = this.optionsText = new TaggedText("", {
            "default": this._sharedTextStyle,
            "selected": {
                fill: 0xffffff,
            }
        });
        optionsText.position.set(4, 2);
        optionsContainer.addChild(optionsText);

        let updating: boolean = false;
        buttonify(optionsBg, {
            onFire: (ev) => {
                // when the player selects something, close the dropdown and update
                const parsedEv = HelperFunctions.parseInteractionEvent(ev);
                const relative = getRelativePosition(parsedEv, optionsBg);
                const selectedInd =
                    Math.min(Math.floor(relative.y / 16), this._currentEntries.length-1);

                this.currentSelectedIndex = selectedInd;
                this.currentSelectedText.text = this._currentEntries[selectedInd];
                this.optionsBg.parent.visible = false;

                if(_settings?.onSelect)
                    _settings.onSelect(this.currentSelectedText.text);
            },
            onPointerMove: (ev) => {
                if(updating) return;
                updating = true;
                // setTimeout(() => {
                    const parsedEv = HelperFunctions.parseInteractionEvent(ev);
                    const relative = getRelativePosition(parsedEv, optionsBg);
                    const selectedInd =
                        Math.min(Math.floor(relative.y / 16), this._currentEntries.length-1);
                    this.update(this._currentEntries, selectedInd);
                    // this.selectedOptionGraphic.position.set(0, selectedInd * 16);
                    // const tempArr = [...this._currentEntries];
                    // tempArr[
                    //     selectedInd
                    //     ] = `<selected>${tempArr[selectedInd]}</selected>`;
                    // this.optionsText.text = tempArr.join("\n");
                    // this.optionsText.update();
                    updating = false;
                // }, 66);
            }
        });

        optionsContainer.visible = false;
        this.onDestroy().add(() => {
            if(CURRENTLY_SELECTED_DROPDOWN === this)
                CURRENTLY_SELECTED_DROPDOWN = null;
        });
    }

    public update(_entries: string[], _defaultSelection?: number): void {
        const selectedInd = Math.max(_defaultSelection || 0, 0);
        // if(this.currentSelectedIndex === selectedInd) return;
        this._currentEntries = [..._entries];
        this.currentSelectedText.text = this._currentEntries[selectedInd];
        this.optionsBg.height = this._currentEntries.length * 16;
        this.currentSelectedIndex = selectedInd;
        this.selectedOptionGraphic.position.set(0, 16 * selectedInd);

        const tempArr = [...this._currentEntries];
        tempArr[
            selectedInd
        ] = `<selected>${tempArr[selectedInd]}</selected>`;
        this.optionsText.text = tempArr.join("\n");
        this.optionsText.update();
    }
}